import {
  MBD_ITEMS,
  MBD_TYPE,
} from '@shared/constants/meaningful-behaviour-data';

const buildDetailsImageGalleryAttributes = ({
  hotelId,
  mediaType,
  sortId,
}: {
  hotelId?: string;
  mediaType?: string;
  sortId: number;
}) => {
  if (!hotelId) {
    return {};
  }

  const { id, name } = MBD_ITEMS[MBD_TYPE.HOTEL_DETAILS_IMAGE_GALLERY];
  const trackingId = `${id}_${hotelId}_${sortId}`;

  return {
    id: mediaType ? `${trackingId}_${mediaType}` : trackingId,
    name: mediaType ? `${name}_${mediaType}` : name,
  };
};

export { buildDetailsImageGalleryAttributes };
